import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { logout, isLoggedIn } from "../reducers/auth";

const Logout = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutStatus = useSelector(isLoggedIn);

  useEffect(() => {
    console.log("DISPATCH LOGOUT");
    dispatch(logout());
  }, []);

  useEffect(() => {
    if(!logoutStatus)
     navigate('/login');
  }, [logoutStatus]);

  return (
    <div>
        Logging out...
    </div>
  );
};
export default Logout;